export const binderTemplateFields = [
  "hideDate",
  "oeuvresDescriptionEnsemble",
  "oeuvresDescriptionSousTitre",
  "oeuvresDescriptionAutreTitre",
  "oeuvresDescriptionReference",
] as const;

export const simpleTemplateFields = [
  ...binderTemplateFields,
  "oeuvresValidationNotesDeTravail",
  "oeuvresValidationRemarquesPubliques",
  // TODO: Estimation
  // "oeuvresValorisationEstimation",
] as const;

export const completeTemplateFields = [
  ...simpleTemplateFields,
  //   ...simpleTemplateFields.filter(field => field !== "oeuvresValorisationEstimation"),
  "oeuvresLocalisationHistoriqueLieuDeStockage",
  "oeuvresLocalisationHistorique",
  "oeuvresRegieNotesCondition",
  "oeuvresDansExposition",
  "oeuvresDansBibliographie",
  "oeuvresDansVentes",
  "oeuvresDocumentsAdministratifsNotesDocumentsAdministratifs",
  // COMMENTED OUT SINCE IT DIDN'T WORK IN V2
  //   "relatedPhotos",
  //   "relatedDocuments",
  //   "relatedWritings",
  // TODO: Estimation
  // "oeuvresValorisationEstimation",
] as const;

export type ArtworkPrintSettings = Record<
  (typeof completeTemplateFields)[number],
  boolean
>;
